import { Box, Drawer, type DrawerProps, Stack } from "@mui/material";
import { ReactNode } from "react";

interface SidebarFilterProps extends DrawerProps {
  children: ReactNode;
  open: boolean;
  width?: string;
}

// NOTE: remove this once we yeet bootstrap
const TOP_LEVEL_PADDING_OFFSET = "12px";

const SidebarFilter = ({
  children,
  open,
  anchor,
  width = "300px",
}: SidebarFilterProps) => {
  return (
    <Drawer
      open={open}
      variant="persistent"
      anchor={anchor}
      sx={{
        width: width,
        height: "100%",
        maxHeight: "100vh",
        position: "sticky",
        top: 0,
        bottom: 0,
        overflowX: "hidden",
        overflowY: open ? "auto" : "hidden",
        zIndex: open ? "initial" : -1,

        "& .MuiDrawer-paper": {
          width: width,
          boxSizing: "border-box",
          position: "sticky",

          marginBottom: 0,
          scrollbarGutter: "stable",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: "5px 0 0 5px",
          paddingY: 1,
        },

        // DOCKED LEFT
        "&.MuiDrawer-anchorLeft": {
          marginLeft: `-${TOP_LEVEL_PADDING_OFFSET}`,
        },
        ".MuiDrawer-paperAnchorLeft": {
          paddingRight: 2,
          paddingLeft: 1,
          borderLeft: "none",
        },

        // DOCKED RIGHT
        "&.MuiDrawer-anchorRight": {
          marginRight: `-${TOP_LEVEL_PADDING_OFFSET}`,
        },
        ".MuiDrawer-paperAnchorRight": {
          paddingLeft: 2,
          paddingRight: 1,
          borderRight: "none",
        },
      }}
    >
      <Box component="form">
        <Stack gap={1.5}>{children}</Stack>
      </Box>
    </Drawer>
  );
};

export default SidebarFilter;
